import { Link, useNavigate } from 'react-router'
import { toast } from 'sonner'

import { FeedbackModal } from '@/components/FeedbackModal/FeedbackModal'
import { Button } from '@/components/ui/button'
import { ForgotPasswordForm } from '@/forms/ForgotPasswordForm'
import { useDisclosure } from '@/hooks/use-disclosure'
import { AuthCard, AuthFooter, AuthLayout } from '@/layouts/AuthLayout'
import { useAuth } from '@/lib/auth'

export default function ForgotPasswordPage() {
  useAuth({
    middleware: 'guest',
    tmp: 'ForgotPassword',
  })

  const navigate = useNavigate()
  const { isOpen: isFeedbackOpen, onToggle } = useDisclosure()

  return (
    <AuthLayout>
      <title>Zapomenuté heslo</title>

      <AuthCard title="Zapomenuté heslo" description="Zadejte e-mail k účtu. Pošleme vám kód pro nastavení nového hesla.">
          <ForgotPasswordForm
            onSuccess={(response) => {
              if (response.status === 200 || response.status === 204) {
                toast.success('E-mail odeslán', {
                  description: 'Na zadaný e-mail jsme vám odeslali kód pro obnovení hesla.',
                  duration: 5000,
                  onDismiss: () => {
                    navigate('/auth/reset-password')
                  },
                })
                return
              }

              toast.error('Chyba resetu hesla', {
                description: 'Vypadá to, že server má potíže. Zkuste to prosím později.',
                duration: 5000,
                onDismiss: () => {
                  window.location.reload()
                },
              })
            }}
          />
      </AuthCard>

      <AuthFooter>
        <Link to="/auth/login" className="text-sm text-muted-foreground hover:text-foreground">
          Zpět na přihlášení
        </Link>

        <Button variant='link' size='sm' onClick={onToggle}>Zpětná vazba</Button>
        <FeedbackModal isOpen={isFeedbackOpen} onToggle={onToggle} />
      </AuthFooter>
    </AuthLayout>
  )
}
